import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

const MARKDOWN_LINK_RE = /\[([^\]]+)\]\(([^)]+)\)/g;

/** Renders legal copy with optional `[label](/path)` internal links. */
export function renderLegalParagraph(text: string, keyPrefix: string): ReactNode {
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let linkIndex = 0;

  for (const match of text.matchAll(MARKDOWN_LINK_RE)) {
    const index = match.index ?? 0;
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }
    const href = match[2];
    const isExternal = href.startsWith('http://') || href.startsWith('https://');
    parts.push(
      isExternal ? (
        <a
          key={`${keyPrefix}-link-${linkIndex}`}
          href={href}
          className="text-brand-accent underline-offset-4 hover:underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          {match[1]}
        </a>
      ) : (
        <Link
          key={`${keyPrefix}-link-${linkIndex}`}
          to={href}
          className="text-brand-accent underline-offset-4 hover:underline"
        >
          {match[1]}
        </Link>
      ),
    );
    linkIndex += 1;
    lastIndex = index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return <p>{parts.length > 0 ? parts : text}</p>;
}

export function legalSectionId(heading: string): string | undefined {
  const m = heading.match(/^(\d+)\./);
  return m ? `section-${m[1]}` : undefined;
}
